function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotiz = function SvgNotiz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.9 19"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 4a4.951 4.951 0 0 1 5 5 3.661 3.661 0 0 1-.4 1.8l2.9 2.9a11.725 11.725 0 0 0 3.4-4.8 11.782 11.782 0 0 0-11-7.5 10.879 10.879 0 0 0-4 .7l2.2 2.2A6.279 6.279 0 0 1 11 4ZM1 1.3l2.3 2.3.4.4A12.37 12.37 0 0 0 0 9a11.782 11.782 0 0 0 11 7.5 12.728 12.728 0 0 0 4.4-.8l.4.4 2.9 2.9 1.3-1.3L2.3 0Zm5.5 5.5L8 8.4V9a2.946 2.946 0 0 0 3 3 1.268 1.268 0 0 0 .6-.1l1.6 1.5a4.282 4.282 0 0 1-2.2.6 4.951 4.951 0 0 1-5-5 5.45 5.45 0 0 1 .5-2.2Zm4.3-.8L14 9.2V9a2.946 2.946 0 0 0-3-3Z",
    style: {
      fill: "#0a1343"
    }
  }));
};
export default SvgNotiz;